module.exports = __webpack_public_path__ + "img/selected-presential.c2f16e5a.svg";